__webpack_require__.p = "/apps/registration/js/";